export const FALLBACK_BUTTON_COLOR = '#018dd3';

export const JOB_TABS = [
	{ key: 'nearby', label: 'Nearby' },
	{ key: 'department', label: 'Your Department' },
	{ key: 'company', label: 'Company Wide' },
];

export const ONBOARDING_STEPS = [
	{ key: 'skills', label: 'Add Skills', complete: false },
	{ key: 'experience', label: 'Add Experience', complete: false },
	{ key: 'open', label: 'Open to New Roles', complete: false },
	{ key: 'apply', label: 'Apply', complete: false },
];

export const HERO_BG_FALLBACK =
	'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=70';
